import { createFileRoute } from '@tanstack/react-router'

import { UserPage } from '#/modules/users/user-page'

export const Route = createFileRoute('/_shell/users/$userId')({
  component: function UserRoute() {
    const { userId } = Route.useParams()
    return <UserPage userId={userId} />
  },
})
